var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.componentName)?_c(_vm.componentName,{tag:"component"}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }